import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { analyticsService } from '../utils/analytics'
import { trackMetaPageView } from '../utils/metaPixel'

/**
 * Normalizes a pathname by replacing UUIDs and numeric IDs with :id
 * e.g. /claim/abc123def -> /claim/:code
 */
function normalizePath(pathname: string): string {
  return pathname
    .replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, ':id')
    .replace(/\/\d+(?=\/|$)/g, '/:id')
}

export default function RouteAnalytics() {
  const location = useLocation()

  useEffect(() => {
    const screenName = normalizePath(location.pathname)
    analyticsService.logScreenView(screenName)
    // Pixel doesn't auto-track SPA navigations — fire PageView on each route change
    // so ad attribution sees post-click pageviews beyond the first landing.
    trackMetaPageView()
  }, [location.pathname])

  return null
}
